import 'css-chunk:src/css/index.module.scss';export default {
  "wrapper": "wrapper__YcdMu",
  "contentBox": "contentBox__K36gR",
  "move": "move__97BgV",
  "menuBox": "menuBox__zhAgw"
};